"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringifyPath = void 0;
var engine_types_1 = require("@verified/c11-engine.types");
var isString_1 = __importDefault(require("lodash/isString"));
var isNumber_1 = __importDefault(require("lodash/isNumber"));
var stringifyPath = function (path) {
    if (!path) {
        return;
    }
    var result = path
        .reduce(function (acc, x) {
        if (x.type === engine_types_1.ValueTypes.CONST) {
            if ((0, isString_1.default)(x.value)) {
                acc.push(x.value);
            }
            else if ((0, isNumber_1.default)(x.value)) {
                acc.push(x.value.toString());
            }
            else {
                acc.push("<?>");
            }
        }
        else if (x.type === engine_types_1.ValueTypes.EXTERNAL) {
            acc.push("<prop." + x.path.join(".") + ">");
        }
        else if (x.type === engine_types_1.ValueTypes.INTERNAL) {
            acc.push("<arg." + x.path.join(".") + ">");
        }
        else if (x.type === engine_types_1.ValueTypes.INVOKE) {
            acc.push("<param." + x.path.join(".") + ">");
        }
        else {
            acc.push("<unknown>");
        }
        return acc;
    }, [])
        .join(".");
    return result;
};
exports.stringifyPath = stringifyPath;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3RyaW5naWZ5UGF0aC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9ncmFwaC9zdHJpbmdpZnlQYXRoLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBLGtEQUErRDtBQUMvRCw2REFBdUM7QUFDdkMsNkRBQXVDO0FBRWhDLElBQU0sYUFBYSxHQUFHLFVBQUMsSUFBc0I7SUFDbEQsSUFBSSxDQUFDLElBQUksRUFBRTtRQUNULE9BQU87S0FDUjtJQUVELElBQU0sTUFBTSxHQUFHLElBQUk7U0FDaEIsTUFBTSxDQUFDLFVBQUMsR0FBRyxFQUFFLENBQUM7UUFDYixJQUFJLENBQUMsQ0FBQyxJQUFJLEtBQUsseUJBQVUsQ0FBQyxLQUFLLEVBQUU7WUFDL0IsSUFBSSxJQUFBLGtCQUFRLEVBQUMsQ0FBQyxDQUFDLEtBQUssQ0FBQyxFQUFFO2dCQUNyQixHQUFHLENBQUMsSUFBSSxDQUFDLENBQUMsQ0FBQyxLQUFLLENBQUMsQ0FBQzthQUNuQjtpQkFBTSxJQUFJLElBQUEsa0JBQVEsRUFBQyxDQUFDLENBQUMsS0FBSyxDQUFDLEVBQUU7Z0JBQzVCLEdBQUcsQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFDLEtBQUssQ0FBQyxRQUFRLEVBQUUsQ0FBQyxDQUFDO2FBQzlCO2lCQUFNO2dCQUNMLEdBQUcsQ0FBQyxJQUFJLENBQUMsS0FBSyxDQUFDLENBQUM7YUFDakI7U0FDRjthQUFNLElBQUksQ0FBQyxDQUFDLElBQUksS0FBSyx5QkFBVSxDQUFDLFFBQVEsRUFBRTtZQUN6QyxHQUFHLENBQUMsSUFBSSxDQUFDLFdBQVMsQ0FBQyxDQUFDLElBQUksQ0FBQyxJQUFJLENBQUMsR0FBRyxDQUFDLE1BQUcsQ0FBQyxDQUFDO1NBQ3hDO2FBQU0sSUFBSSxDQUFDLENBQUMsSUFBSSxLQUFLLHlCQUFVLENBQUMsUUFBUSxFQUFFO1lBQ3pDLEdBQUcsQ0FBQyxJQUFJLENBQUMsVUFBUSxDQUFDLENBQUMsSUFBSSxDQUFDLElBQUksQ0FBQyxHQUFHLENBQUMsTUFBRyxDQUFDLENBQUM7U0FDdkM7YUFBTSxJQUFJLENBQUMsQ0FBQyxJQUFJLEtBQUsseUJBQVUsQ0FBQyxNQUFNLEVBQUU7WUFDdkMsR0FBRyxDQUFDLElBQUksQ0FBQyxZQUFVLENBQUMsQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLEdBQUcsQ0FBQyxNQUFHLENBQUMsQ0FBQztTQUN6QzthQUFNO1lBQ0wsR0FBRyxDQUFDLElBQUksQ0FBQyxXQUFXLENBQUMsQ0FBQztTQUN2QjtRQUVELE9BQU8sR0FBRyxDQUFDO0lBQ2IsQ0FBQyxFQUFFLEVBQWMsQ0FBQztTQUNqQixJQUFJLENBQUMsR0FBRyxDQUFDLENBQUM7SUFFYixPQUFPLE1BQU0sQ0FBQztBQUNoQixDQUFDLENBQUM7QUE5QlcsUUFBQSxhQUFhLGlCQThCeEIifQ==